module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Consulta de Chamados'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Lista',
        href: '#'
      }, {
        text: 'Chamados',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.table.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.table.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "z-index": "9"
    }
  }, [_vm._v("\n                    Status:\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listaStatus),
      expression: "listaStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abrangencia"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listaStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Aguardando Atendimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Em Atendimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Aguardando Avaliação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Chamado Avaliado")])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "z-index": "9"
    }
  }, [_vm._v("\n                    Área Responsável:\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaResponsavel),
      expression: "areaResponsavel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abrangencia"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaResponsavel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.areas), function(area) {
    return _c('option', {
      domProps: {
        "value": area.area_responsavel
      }
    }, [_vm._v(_vm._s(area.area_responsavel))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "z-index": "9"
    }
  }, [_vm._v("\n                    Carteira:\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carteira),
      expression: "carteira"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "carteira"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.carteiras), function(carteira) {
    return _c('option', {
      domProps: {
        "value": carteira
      }
    }, [_vm._v(" " + _vm._s(carteira))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "z-index": "9"
    }
  }, [_vm._v("\n                    Analista:\n                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSelecionado),
      expression: "usuarioSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuario"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.usuarioSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.usuarios), function(usu) {
    return _c('option', {
      domProps: {
        "value": usu.id
      }
    }, [_vm._v(_vm._s(usu.ds_nome_usuario))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "alinhar"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
    }],
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'> Limpar todos os filtros </span> </h5>'
    },
    on: {
      "click": _vm.limpaFiltros
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "position": "relative",
      "right": "-50px",
      "top": "-15px"
    }
  }, [_c('table', {
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "width": "90%",
      "height": "80%",
      "id": "table-delegate"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.quantidadeChamadosResult), function(chamado) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "text-align": "center",
        "width": "13%"
      }
    }, [_vm._v(_vm._s(chamado.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "text-align": "center",
        "width": "13%"
      }
    }, [_vm._v(_vm._s(chamado.quantidade))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.meusChamados === false) ? _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "position": "relative",
      "right": "-50px",
      "top": "-140px"
    }
  }, [_c('div', [_c('br'), _vm._v("\n                    Olá, "), _c('b', [_vm._v(_vm._s(this.usuarioLogado.ds_nome_usuario))]), _vm._v(".\n                    "), _c('br'), _vm._v("\n                    Você tem "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.qtdMeusChamados) + " ")])]), _vm._v(" "), (_vm.qtdMeusChamados === 1) ? _c('span', [_vm._v("chamado ")]) : _c('span', [_vm._v("chamados ")]), _vm._v(" em seu nome.\n                    "), _c('br'), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#0a568c",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.filtraMeusChamados
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("   Mostrar Meus Chamados")])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.meusChamados === true) ? _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "position": "relative",
      "right": "-50px",
      "top": "-140px"
    }
  }, [_c('div', [_c('br'), _vm._v("\n                    Olá, "), _c('b', [_vm._v(_vm._s(this.usuarioLogado.ds_nome_usuario))]), _vm._v(".\n                    "), _c('br'), _vm._v("\n                    Você tem "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.qtdMeusChamados) + " ")])]), _vm._v(" "), (_vm.qtdMeusChamados === 1) ? _c('span', [_vm._v("chamado ")]) : _c('span', [_vm._v("chamados ")]), _vm._v(" em seu nome.\n                    "), _c('br'), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#0a568c",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.filtraMeusChamados
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("   Mostrar Meus Chamados")])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "position": "relative",
      "top": "-50px"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "table",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.itemsFiltrados,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "data_inclusao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "projeto",
      fn: function(row) {
        return [(row.item.processo_id) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: "perspective",
              distance: "1",
              size: "large",
              interactive: true,
              theme: "dark",
              placement: "left"
            }),
            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
          }],
          attrs: {
            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'ID:  ' + '</span>' + row.item.processo_id + '</h5>'
          }
        }, [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!row.item.processo_id) ? _c('div', [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e()]
      }
    }, {
      key: "status.status",
      fn: function(row) {
        return [(row.value === 'Aguardando Atendimento') ? _c('span', {
          staticStyle: {
            "color": "#f40022"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Em Atendimento') ? _c('span', {
          staticStyle: {
            "color": "#67af6a"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Aguardando Avaliação') ? _c('span', {
          staticStyle: {
            "color": "#00569f"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Avaliado') ? _c('span', {
          staticStyle: {
            "color": "#000c9f"
          }
        }, [_vm._v(_vm._s(row.value)), _c('br'), _c('span', {
          staticStyle: {
            "color": "#a0a0a0",
            "font-size": "small"
          }
        }, [_vm._v("(Aguardando Encerramento)")])]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Encerrado') ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: "perspective",
              distance: "1",
              size: "large",
              interactive: true,
              theme: "dark",
              placement: "left"
            }),
            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
          }],
          staticStyle: {
            "color": "#020202"
          },
          attrs: {
            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Data de Encerramento:  ' + '</span>' + _vm.formata(row.item.data_encerramento) + '</h5>'
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e()]
      }
    }, {
      key: "descricao",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: "perspective",
              distance: "1",
              size: "large",
              interactive: true,
              theme: "dark",
              placement: "left"
            }),
            expression: "{ inertia : true, arrow : true,  animation : \"perspective\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"left\" }"
          }],
          attrs: {
            "title": '<h5>' + row.value + '</h5>'
          }
        }, [(row.value.length > 50) ? _c('span', [_vm._v(_vm._s(row.value.substring(0, 50) + "..."))]) : _c('span', [_vm._v(_vm._s(row.value))])])]
      }
    }, {
      key: "data_encerramento",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "dt_atualizado",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false,
            "to": {
              name: 'cadastro-chamado-edita',
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Entrar")])], 1)]
      }
    }], null, false, 1041045201)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.itemsFiltrados.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "position": "relative",
      "top": "30px"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "table",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.itemsFiltrados,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "data_inclusao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "projeto",
      fn: function(row) {
        return [(row.item.processo_id) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: "scale",
              distance: "1",
              size: "large",
              interactive: true,
              theme: "dark",
              placement: "right"
            }),
            expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
          }],
          attrs: {
            "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'ID:  ' + '</span>' + row.item.processo_id + '</h5>'
          }
        }, [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!row.item.processo_id) ? _c('div', [_vm._v("\n                          " + _vm._s(row.value) + "\n                        ")]) : _vm._e()]
      }
    }, {
      key: "carteira",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "status.status",
      fn: function(row) {
        return [(row.value === 'Aguardando Atendimento') ? _c('span', {
          staticStyle: {
            "color": "#f40022"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Em Atendimento') ? _c('span', {
          staticStyle: {
            "color": "#67af6a"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Aguardando Avaliação') ? _c('span', {
          staticStyle: {
            "color": "#00569f"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Avaliado') ? _c('span', {
          staticStyle: {
            "color": "#000c9f"
          }
        }, [_vm._v(_vm._s(row.value)), _c('br'), _c('span', {
          staticStyle: {
            "color": "#a0a0a0",
            "font-size": "small"
          }
        }, [_vm._v("(Aguardando Encerramento)")])]) : _vm._e(), _vm._v(" "), (row.value === 'Chamado Encerrado') ? _c('span', {
          staticStyle: {
            "color": "#020202"
          }
        }, [_vm._v(_vm._s(row.value))]) : _vm._e()]
      }
    }, {
      key: "descricao",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: "scale",
              distance: "1",
              size: "large",
              interactive: true,
              theme: "dark",
              placement: "right"
            }),
            expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\" }"
          }],
          attrs: {
            "title": '<h5>' + row.value + '</h5>'
          }
        }, [(row.value.length > 50) ? _c('span', [_vm._v(_vm._s(row.value.substring(0, 50) + "..."))]) : _c('span', [_vm._v(_vm._s(row.value))])])]
      }
    }, {
      key: "data_encerramento",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "dt_atualizado",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false,
            "to": {
              name: 'cadastro-chamado-edita',
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Entrar")])], 1)]
      }
    }], null, false, 1752874914)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.itemsFiltrados.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1) : _vm._e()])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Chamados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('caption', {
    staticStyle: {
      "text-align": "center",
      "color": "#0f7b9f"
    }
  }, [_c('b', [_vm._v("Total de Chamados por Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "13%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "13%"
    }
  }, [_vm._v("Quantidade de Chamados")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aedabec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/chamado/ListaChamado.vue
// module id = 1940
// module chunks = 1